import { EntityId } from '@smartsheet-dataflow/formjs-react';
import { TextInput } from '@smartsheet/lodestar-core';
import React from 'react';

export interface InputNumberProps extends EntityId {
  value: string;
  readonly: boolean;
  onChange: any;
}

export const InputNumber = ({
  id,
  value,
  readonly,
  onChange,
}: InputNumberProps) => {
  return (
    <TextInput
      id={id}
      type="number"
      value={value}
      onChange={onChange}
      readOnly={readonly}
    />
  );
};
